import { useEffect, useState } from "react";
import { Grid2, Typography, Button, Box, TextField } from "@mui/material";
import NumOtpStyles from "./SignUpPhOtp.module.css";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import { useDispatch, useSelector } from "react-redux";
import { checkAndNavigate, generateMobileOtp, setbankData, setDigiData, setNomineData, setPanData, setpersonalData, setPlanData, setuserData, verifyMobileOtp } from "../../../Redux/usersSlice";
import { useNavigate } from "react-router-dom";
import Logo from '../../../Assets/Images/logo.svg';
import EditIcon from '@mui/icons-material/Edit';
import collab from '../../../Assets/Images/collab1.svg';

export default function NumOtp() {

  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, userData,source } = useSelector(state => state.user);

  const [clientErr, setCleintErr] = useState("")
   const [timeLeft, setTimeLeft] = useState(20); // ⏳ 600 seconds countdown


  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "mobile_otp_page_viewed",
      page_path: window.location.pathname
    });
  }, []);

 // ⏳ Countdown Timer
  useEffect(() => {
    if (timeLeft <= 0) return; // stop if expired
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer); // cleanup
  }, [timeLeft]);

  // Redirect logic
  useEffect(() => {
    if (!userData?.mobile) {
      // No mobile number - go back to phone entry
      navigate('/');
      return;
    }

    if (userData?.steps) { // Has steps = mobile verified
      const isEmailVerified = userData.steps?.["Email Verify"]?.status;
      navigate(isEmailVerified ? '/signupcongrats' : '/signupemail');
    }
  }, [userData, navigate]);


  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value) && value.length <= 1) {
      const newOtp = otp.split("");
      newOtp[index] = value;
      const updatedOtp = newOtp.join(""); 
      console.log("updatedOtp", updatedOtp, updatedOtp.length === 4)
      setOtp(updatedOtp);


      if (value && index < 4) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) nextInput.focus();
      }

      if (updatedOtp.length === 4) {
        console.log("OTP entered:", updatedOtp);
        handleOtpSubmit(updatedOtp); // Call API here
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleOtpSubmit = async (updatedOtp) => {
    // e.preventDefault();
    if (updatedOtp.length !== 4) {
      setCleintErr("Please Enter Otp")
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "mobile_otp_entered",
      page_path: window.location.pathname
    });
    
    console.log(
     { mobile: userData.mobile,
          otp: updatedOtp}
    )

    try {
      const response = await dispatch(verifyMobileOtp({
        mobile: userData.mobile,
        otp: updatedOtp
      })).unwrap();
      if (response.data?.success) {
        if (response.data?.user) {
          dispatch(setuserData(response.data?.user))
          if (response.data?.personal) {
            dispatch(setpersonalData(response.data?.personal))
          }
          if (response.data?.bank) {
            dispatch(setbankData(response.data?.bank))
          }
          if (response.data?.digilocker) {
            dispatch(setDigiData(response.data?.digilocker))
          }
          if (response.data?.nominee) {
            dispatch(setNomineData(response.data?.nominee))
          }
          if (response.data?.plan) {
            dispatch(setPlanData(response.data?.plan))
          }
          if (response.data?.pan) {
            dispatch(setPanData(response.data?.pan))
          }
          const { payload } = await dispatch(checkAndNavigate());

          console.log(payload.allComplete)

          if (payload.allComplete) {
            // All required steps completed - go to products
            console.log("Navigating to dis page...")
            navigate("/dis");
          } else {
            const isEmailVerified = response.data.user.steps?.["Email Verify"]?.status;
            navigate(isEmailVerified ? '/signupcongrats' : '/signupemail');
          }
        }
      } else if (response.data?.message === "Invalid mobile otp") {
        setCleintErr("Invalid mobile otp")
      } else if (response.data?.message === "Please provide valid mobile or otp") {
        setCleintErr("Please provide valid mobile or otp")
      } else if (response.data?.message === "Mobile Otp already verified") {
        setCleintErr("Mobile Otp already verified")
      }
       else if (response.data?.message === "OTP expired, please request a new one") {
        setCleintErr("OTP expired, please request a new one")
      }
      // Navigation will be handled by the useEffect
    } catch (error) {
      // Error will be displayed from Redux state
      console.error('OTP verification failed:', error);
      setCleintErr(error?.data?.data?.message)
    }
  };

  const handleResendOtp = async (e) => {
    e.preventDefault();

    try {
      const response = await dispatch(
        generateMobileOtp({ mobile: userData?.mobile, referral_code: localStorage.getItem("refCode") || ""})
      ).unwrap();

      if (response.data?.success) {
        // Reset timer and clear any old error
        setTimeLeft(20);
        setCleintErr("");

        // Update userData if backend sends updated user object
        if (response.data?.user) {
          dispatch(setuserData(response.data?.user));
        }

      } else if (response.data?.message) {
        setCleintErr(response.data.message);
      }

    } catch (error) {
      console.error("Resend OTP failed:", error);
      setCleintErr(error?.data?.data?.message || "Something went wrong, please try again");
    }
  };

  return (
    <main>
      <Grid2
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `url(${SignUpBg})`, // Correct background syntax
          backgroundSize: "cover", // Makes the image cover the full container
          backgroundPosition: "center", // Centers the image
          backgroundRepeat: "no-repeat", // Prevents tiling
          "@media (max-width:600px)": {
            justifyContent: "start"
          }
        }}
      >
        <Grid2 className={NumOtpStyles.content_wrapper}>

          <img
            src={source == "cosmos" ? collab : Logo}
            alt="Logo"
            className={source == "cosmos" ? NumOtpStyles.twologo : NumOtpStyles.nav_logo}
          />
          {
            source == "cosmos" &&
            <Typography className={NumOtpStyles.txt}>
              Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
            </Typography>
          }
          <Typography className={NumOtpStyles.heading}>OTP</Typography>
          <Typography className={NumOtpStyles.sub_title}>
            Enter OTP sent to {userData?.mobile}<EditIcon
              sx={{
                fontSize: {
                  xs: "15px", // small screens (mobile)
                  sm: "20px", // tablets
                  md: "22px", // medium laptops
                  lg: "24px", // large desktops
                },
                ml:"6px",
                color: "#1565c0",
                cursor: "pointer",
                "&:hover": { color: "blue" },
              }}
               onClick={() => navigate("/")} // 👉 add your edit action here
            />
          </Typography> 

          <form autoComplete="off">
            <input type="text" name="fakeuser" autoComplete="username" style={{ display: "none" }} />
            <input type="password" name="fakepass" autoComplete="new-password" style={{ display: "none" }} />

          <Box className={NumOtpStyles.otp_container}>
            {[...Array(4)].map((_, index) => (
              <TextField
                key={index}
                id={`otp-${index}`}
                value={otp[index] || ""}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                inputProps={{
                  maxLength: 1,
                  className: NumOtpStyles.otp_input,
                  type: "tel",
                  inputMode: "numeric",
                  "aria-label": `OTP digit ${index + 1}`,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    bgcolor: "white",
                    width: "94px",
                    height: "75px",
                    borderColor: "#ABABAB80 !important",
                    "& fieldset": {
                        borderColor: "#ABABAB80",
                      },
                      "&:hover fieldset": {
                        borderColor: "#ABABAB80 !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#ABABAB80 !important",
                      },
                      "@media (max-width: 550px)": { width: "80px", height: "65px" },
                      "@media (max-width: 480px)": { width: "70px", height: "60px" },
                      "@media (max-width: 420px)": { width: "60px", height: "50px" },
                      "@media (max-width: 360px)": { width: "55px", height: "42px" },
                    },
                  }}
                />
              ))}
            </Box>
          </form>

          {clientErr && <Typography color="error" sx={{ marginTop: "20px !important" }}>{clientErr}</Typography>}

          {/* ⏳ Show Timer */}
          <Typography
            sx={{
              marginTop: "15px",
              fontWeight: 500,
              fontSize: "18px", // default (desktop)
              fontFamily:"Inter400 !important",
              textAlign: "center",
              "@media (max-width:600px)": {
                fontSize: "16px",
              },
              "@media (max-width:480px)": {
                fontSize: "14px",
              },
              "@media (max-width:360px)": {
                fontSize: "12px",
              },
            }}
          >
            {timeLeft > 0
              ? `Resend OTP in ${String(Math.floor(timeLeft / 60)).padStart(2, "0")}:${String(timeLeft % 60).padStart(2, "0")}`
              : <Button onClick={handleResendOtp} sx={{ textTransform: "Capitalize", fontFamily: "Inter400 !important", fontSize: "18px", color:"#000000"}}>Resend Otp</Button>}
          </Typography>


          <Grid2 className={NumOtpStyles.button_card}>
            <Button className={NumOtpStyles.button} onClick={handleOtpSubmit}>
              {loading ? 'Verifying...' : 'Proceed'}
            </Button>

          </Grid2>
        </Grid2>
      </Grid2>
    </main>
  );
}
